import { Link } from 'react-router-dom';
import { useAuth } from '../../../../AuthContext';
import { Permissions } from '../../../../utils/permissions';
import { formatNaira, grossAmount } from '../../../../utils/money';
import { formatUtc } from '../../../../utils/datetime';
import { DataTable, StatusPill, TableCard } from '../../../ui';

const columns = [
  { key: 'reference', header: 'Reference', className: 'whitespace-nowrap' },
  { key: 'counterparty', header: 'Counterparty' },
  { key: 'direction', header: 'Direction', className: 'capitalize' },
  { key: 'gross', header: 'Gross', align: 'right', render: (row) => formatNaira(grossAmount(row)) },
  {
    key: 'discount_amount',
    header: 'Discount',
    align: 'right',
    render: (row) => formatNaira(row.discount_amount),
  },
  { key: 'amount', header: 'Amount', align: 'right', render: (row) => formatNaira(row.amount) },
  { key: 'status', header: 'Status', render: (row) => <StatusPill status={row.status} /> },
  { key: 'created_at', header: 'Created (UTC)', render: (row) => formatUtc(row.created_at) },
];

const RecentTransactions = ({ rows = [], loading }) => {
  const { hasPermission } = useAuth();

  return (
    <TableCard
      title="Recent transactions"
      className="mb-0"
      toolbar={
        hasPermission(Permissions.transactions) && (
          <Link to="/layout/transactions" className="btn btn-outline-primary btn-sm">
            View all
          </Link>
        )
      }
    >
      <DataTable
        columns={columns}
        rows={rows}
        rowKey={(row) => row.reference}
        serial
        loading={loading}
        empty={{
          title: 'No transactions yet',
          message: 'No transaction was recorded in the selected period.',
        }}
      />
    </TableCard>
  );
};

export default RecentTransactions;
